import { Stack } from '@mui/material'
import { Modal } from 'ComponentLibrary/src/piazza/modals'
import { Typography } from 'ComponentLibrary/src/piazza/text'
import { tokens } from 'ComponentLibrary/style-dictionary/output'

export type UnsavedChangesConfirmationModalProps = {
    isOpen: boolean
    isSaving: boolean
    onCancel: () => void
    onDiscard: () => void
    onSave: () => void
    title?: string
    message?: string
    cancelLabel?: string
    discardLabel?: string
    saveLabel?: string
}

export function UnsavedChangesConfirmationModal({
    isOpen,
    isSaving,
    onCancel,
    onDiscard,
    onSave,
    title = 'Nicht gespeicherte Änderungen',
    message = 'Was soll mit Ihren Änderungen passieren, bevor Sie die Seite verlassen?',
    cancelLabel = 'Abbrechen',
    discardLabel = 'Verwerfen & Weiter',
    saveLabel = 'Speichern & Weiter',
}: UnsavedChangesConfirmationModalProps) {
    return (
        <Modal
            title={title}
            isOpen={isOpen}
            onClose={onCancel}
            showCloseIcon={!isSaving}
            showLoading={isSaving}
            disableBackdropClose={isSaving}
            width="500px"
            footerProps={{
                destructiveButton: {
                    text: discardLabel,
                    onClick: onDiscard,
                    disabled: isSaving,
                },
                secondaryButton: {
                    text: cancelLabel,
                    onClick: onCancel,
                    disabled: isSaving,
                },
                primaryButton: {
                    text: saveLabel,
                    onClick: onSave,
                    disabled: isSaving,
                },
            }}
        >
            <Stack width="100%">
                <Typography variant="textS" color={tokens.ColorTextDefault}>
                    {message}
                </Typography>
            </Stack>
        </Modal>
    )
}
